import { computed, Injectable, inject } from '@angular/core';
import { AuthDataService } from 'src/data-store/auth-data.service';
import { DataService } from 'src/data-store/data.service';
import { UserDataService } from 'src/data-store/user-data.service';
import { ELoginDeviceType } from 'src/models/auth.model';
import { AuthLinksService } from './auth-links.service';
import { DeviceService } from './device.service';

@Injectable({
  providedIn: 'root'
})
export class OauthLoginService {
  private authLinksService = inject(AuthLinksService);
  private authDataService = inject(AuthDataService);
  private dataService = inject(DataService);
  private userDataService = inject(UserDataService);
  private deviceService = inject(DeviceService);

  private userAndTokenExist = computed<boolean>(() => !!this.userDataService.loggedUser() && !!this.authDataService.accessToken());

  public logIn(bcasKey: string): void {
    if (!this.userAndTokenExist()) {
      this.authDataService.resetAuthState();
      this.dataService.resetHideFinancialValues();
      if (this.deviceService.isNativePlatform) {
        this.authDataService.getAuthTokenData(ELoginDeviceType.MOBILE, bcasKey, this.authLinksService.clientRedirectUri);
      } else {
        this.authDataService.getAuthTokenData(ELoginDeviceType.WEB, bcasKey, this.authLinksService.clientRedirectUri);
      }
    }
  }

}

